

    import ResearchItem from 'components/resources/ResearchItem.vue';
    import {ref, defineComponent, PropType} from 'vue';
    import {MetadataResearchArticle, MetadataResearchSection} from 'src/contracts/getMetadataResearchResponse';

    export default defineComponent ({
      name: 'ResearchSectionContainer',
      components: {
        ResearchItem,
      },
      props: {
        researchSectionDataModel: Object as PropType<MetadataResearchSection>,
      },
      setup() {
        return {
          othersExpanded: ref(false)
        }
      },
      methods: {
        showArticles(articles: MetadataResearchArticle[], bestMatch: boolean) {
          return articles?.filter(article => article.is_best_match === bestMatch);
        }
      },
      computed: {
        hasItems(): boolean {
          // eslint-disable-next-line
          return !!((<any>this.researchSectionDataModel)?.coding_advices?.length || (<any>this.researchSectionDataModel)?.articles?.length);
        }
      }
    })
